import React from 'react';
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { useTranslation } from '../../../../hooks/useTranslation';
import dayjs from 'dayjs';
import colors from '../../../../themes/main-colors';
import { useOutageEventsDetails } from '../../hooks/useOutageEventsDetails';

interface Props {
  textColor?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    lastUpdated: (props: { textColor: string }) => ({
      '& p': {
        color: props.textColor,
        margin: 0,
      },
    }),
  }),
);
export const LastUpdatedSection = ({ textColor = colors.noirBlur }: Props) => {
  const { t, richT } = useTranslation();
  const classes = useStyles({ textColor });
  const { lastUpdatedTime } = useOutageEventsDetails();
  return (
    <Box textAlign="center" className={classes.lastUpdated}>
      <Typography variant={'body2'}>
        {richT('OUTAGE_LAST_UPDATED', {
          OUTAGE_UPDATED_DATE: dayjs(lastUpdatedTime, 'MMMM D, YYYY h:mm a')
            .format('MMM D, h:mm a')
            .replace('am', 'AM')
            .replace('pm', 'PM'),
        })}
      </Typography>
      <Typography variant={'body2'}>
        {t('INFORMATION_REFRESH_EVERY_10_MINUTES')}
      </Typography>
    </Box>
  );
};
